import { ChevronRight } from 'lucide-react';

/** A tappable row with a tinted glyph, a name and an optional subtitle: the connect modal's option row and the Facebook Page picker row. */
interface TypeRowProps {
  name: string;
  /** Muted second line under the name. */
  subtitle?: string;
  icon: React.ReactNode;
  iconTintClass: string;
  onClick: () => void;
  buttonRef?: React.Ref<HTMLButtonElement>;
  disabled?: boolean;
  /** Right-side text when disabled. Defaults to "Coming soon"; '' renders nothing. */
  disabledHint?: string;
}

export function TypeRow({
  name,
  subtitle,
  icon,
  iconTintClass,
  onClick,
  buttonRef,
  disabled = false,
  disabledHint = 'Coming soon',
}: TypeRowProps) {
  return (
    <button
      type="button"
      ref={buttonRef}
      onClick={onClick}
      disabled={disabled}
      aria-label={disabled && disabledHint ? `${name} (${disabledHint})` : name}
      className="group flex items-center gap-4 rounded-xl border border-border bg-card p-4 text-left transition hover:border-foreground/30 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-border disabled:hover:bg-card"
    >
      <span className={`flex size-10 shrink-0 items-center justify-center rounded-lg ${iconTintClass}`}>
        {icon}
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-medium">{name}</span>
        {subtitle ? <span className="truncate text-xs text-muted-foreground">{subtitle}</span> : null}
      </span>
      {disabled ? (
        disabledHint ? (
          <span className="shrink-0 text-xs text-muted-foreground">{disabledHint}</span>
        ) : null
      ) : (
        <ChevronRight className="size-4 shrink-0 text-muted-foreground transition group-hover:translate-x-0.5 group-hover:text-foreground" />
      )}
    </button>
  );
}
